import { useTranslation, Trans } from 'react-i18next';
import { Button } from '@resideo/blueprint-oneportal';
import styles from './ResendConfirmModal.module.css';

export interface DeleteConfirmModalProps {
  email: string;
  isActive: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteConfirmModal({
  email,
  isActive,
  isDeleting,
  onConfirm,
  onCancel,
}: DeleteConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <p className={styles.title}>
          {isActive ? t('employees.deleteModal.activeTitle') : t('employees.deleteModal.invitedTitle')}
        </p>
        <p className={styles.body}>
          {isActive ? (
            t('employees.deleteModal.activeBody')
          ) : (
            <Trans
              i18nKey="employees.deleteModal.invitedBody"
              values={{ email }}
              components={{ highlight: <span className={styles.emailHighlight} /> }}
            />
          )}
        </p>
        <div className={styles.actions}>
          <Button variant="highlightTertiary" onClick={onCancel} disabled={isDeleting} style={{ fontWeight: 700 }}>
            {t('employees.resendInviteCancel')}
          </Button>
          <Button variant="destructivePrimary" onClick={onConfirm} disabled={isDeleting} style={{ fontWeight: 700 }}>
            {isDeleting
              ? t('employees.deleteModal.deleting')
              : isActive
                ? t('employees.deleteModal.activeConfirm')
                : t('employees.deleteModal.invitedConfirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
